export type GetPDPSchemaShippingPriceInput = {
  price: number,
  isEntryway: boolean,
  iswhiteGlove: boolean,
}
const priceAnalysisMatrix: Array<{ min: number, max: number, value: string }> = [
  { min: 50, max: 150, value: '14.95' },
  { min: 150, max: 250, value: '27.95' },
  { min: 250, max: 350, value: '37.95' },
  { min: 350, max: 450, value: '47.95' },
  { min: 450, max: 650, value: '67.95' },
  { min: 650, max: 850, value: '87.95' },
  { min: 850, max: 1000, value: '97.95' },
]

export const getPDPSchemaShippingPrice = ({
  price,
  isEntryway,
  iswhiteGlove,
}: GetPDPSchemaShippingPriceInput) => {
  if (iswhiteGlove) {
    return '279.00'
  }
  if (isEntryway) {
    return '179.00'
  }
  if (price <= 50) {
    return '9.95'
  }
  const tenPercent = parseFloat(`${0.1 * parseFloat(`${price || 0}`)}`).toFixed(2)
  return priceAnalysisMatrix.find((r) => price > r.min && price <= r.max)?.value || tenPercent
}
